<span class="x-svg-icon__content contents" [innerHTML]="$svg()"></span>
